import { useEffect, useState } from "react";
import { Col, Row, Typography, Card } from "antd";
import { useStore } from "../../../root-store-context";
import { formatDate } from "../../../Common";
import ProfileInfo from "./ProfileInfo";
import FormView from "./ViewForm";
import "./ViewForm.css";
import Swal from "sweetalert2";
import Spinner from "../../../components/Spinner/Spiner";
import Comments from "./Comment";
import Documents from "./Documents";
import { observer } from "mobx-react-lite";
import UploadButton from "../../../components/UploadButton/RectangleUploadButton";
import FileHelper from "../../../helpers/FileHelper";
import Constants from "./ARCConstant";
import DynamicTable from '../../../components/Table/Table';
import CommonFuncitons from "../../../utils/CommonFunciton";

const PermissionsFields = observer((props) => {
  const {
    SubmissionDetail,
    setSubmissionDetail,
    setShowFileViewer,
    setFilePath,
    setFileName,
    handleViewFile
  } = props;
  const requestData = SubmissionDetail;
  
  var formDetails = requestData?.formData
    ? JSON.parse(requestData?.formData)
    : null;


  return (
    <>
      <div className="local-bootstrap section-wrapper mb-1">
        <Row justify={'center'}>
          <Col sm={18}>
            <p className="secondary-heading mb-1">View Submission Request</p>
            <FormView
              Edit={"view"}
              GetForm={requestData}
              isSupportedDocument={formDetails?.isSupportedDocument}
              components={formDetails?.components}
              id={requestData?.id}
              unitId={requestData?.unitId}
              setShowFileViewer={setShowFileViewer}
              setFilePath={setFilePath}
              setFileName={setFileName}
            />
          </Col>
        </Row>
      </div>

      <div className="comment-doc-wrapper">
        <div className="section-wrapper comment-component-wrap">
          <Comments
            handleViewFile={handleViewFile}
            form={requestData}
            setSubmissionDetail={setSubmissionDetail}
            submissionId={requestData?.submissionId}
          />
        </div>
        <div className="section-wrapper document-component-wrap">
          <Documents
            GetUser={props?.GetUser}
            handleViewFile={handleViewFile}
            form={requestData}
            submissionId={requestData?.submissionId}
          />
        </div>
      </div>
    </>
  );
});

const ArchitecturalRequest = observer(() => {

  const { apiStore, applicationStore } = useStore();

  const [Profile, setProfile] = useState({});
  const [SubmissionDetail, setSubmissionDetail] = useState({});
  const [showFileViewer, setShowFileViewer] = useState(false);
  const [filePath, setFilePath] = useState("");
  const [fileName, setFileName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [appealDoc, setAppealDoc] = useState([]);

  const getRequestId = () => {
    const path = window.location.pathname;
    const splitPath = path.split("/");
    return splitPath[splitPath.length - 1];
  };

  const handleClose = () => {
    setShowFileViewer(false);
  };

  useEffect(() => {
    setIsLoading(true);
    let id = getRequestId();
    apiStore.FormsApiClient.GetSubmissionDetails(id)
      .then((res) => {
        let obj = {};
        if (res?.status) {
          let requestDetails = res?.data;
          setSubmissionDetail(requestDetails);
          const submissionStatus = FileHelper.getDisplaySubmissionStatus(requestDetails?.submissionStatus) 
          const decisionStatus = FileHelper.getDisplaySubmissionStatus(requestDetails?.submissionDecision) 
          var formDetails = requestDetails?.formData
            ? JSON.parse(requestDetails?.formData)
            : null;
          applicationStore.setIsSupportedDocRequired(formDetails?.isSupportedDocRequired)
          const user = {
            ["Request Number"]: requestDetails?.requestNumber,
            ["Submitted By"]: requestDetails?.userName,
            ["Submitted Date"]: formatDate(requestDetails?.submittedDate),

            ["Unit Address"]: requestDetails?.unitName,
            ["Submission Status"]: submissionStatus,
            ...(decisionStatus) && {
            ["Submission Decision"]:decisionStatus,
            },
            ["Association"]: requestDetails?.communityName,
          };
          setProfile(user);
          setProfile(user);
          applicationStore.setsubmissionDate(user)
          applicationStore.setFileList(requestDetails?.files)
          obj.form = JSON.parse(res?.data?.formData);
          setIsLoading(false);
        } else {
          Swal.fire({
            title: "Error",
            text: res?.data?.message,
            icon: "Error",
            confirmButtonColor: "#44637e",
          });
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [apiStore,SubmissionDetail?.submissionStatus]);

  useEffect(() => {
    if (SubmissionDetail?.appealDetail?.files) {
      // Map over the files from EditAndViewFormData and add the `documentType` property
      const updatedFiles =
        SubmissionDetail?.appealDetail?.files.map(
          (file) => ({
            ...file,
            fileId: file?.fileId,
            name: file?.originalFileName,
            docTypeId: file?.docTypeId,
            documentType: file?.docTypeName, // Adding documentType
          })
        );
      // Set the fileList state with the updated data
      setAppealDoc(updatedFiles);
    }
  }, [
    SubmissionDetail?.appealDetail
  ]);
  const handleViewFile = (fileId) => {
    setTimeout(() => {
      window.open(
        `${process.env.REACT_APP_ARCH_API_ENDPOINT.toString()}api/Media/view/?fileId=${fileId?.trim()}`,
        "_blank"
      );
      setShowFileViewer(true);
    }, 100);
  };
  const handleDownload = (data) => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_ARCH_API_ENDPOINT.toString()}api/Media/download?fileId=${data?.fileId}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
 const blockColumns = [
        {
            title: "Original Submission Type",
            dataIndex: "submissionTypesName",
            key: "submissionTypesName",
            render: (text,record) => text || record?.title
        },
         {
            title: "Submission Sub-Type",
            dataIndex: "title",
            key: "title",
            render: (text,record) => text || "-"
        },
        {
            title: "Status",
            dataIndex: "blockActionStatus",
            key: "blockActionStatus",
            ...CommonFuncitons.statusTagColumn(),
        },
        {
            title: "Decision",
            dataIndex: "blockDecision",
            key: "blockDecision",
            ...CommonFuncitons.statusTagColumn({
                isBlank: (record) =>
                    record?.blockActionStatus === CommonFuncitons.SubmissionStatus.Canceled,
            }),
        },
        {
            title: "Decision Reason",
            dataIndex: "decisionReason",
            key: "decisionReason",
            render: (text) => text || "-"
        },
        {
            title: "Status Reason",
            dataIndex: "statusReason",
            key: "statusReason",
            width: 250,
            ellipsis: true,
            render: (text) => text || "-"
        },
         {
            title: "Decision Date",
            dataIndex: "decisionDate",
            key: "decisionDate",
            width: 200,
            className: "dynamic-table-nowrap-cell",
           render: (value) => formatDate(value),
        }
    ];
    const statusReason=FileHelper.committeeStatuses.includes(SubmissionDetail?.submissionStatus) ? Constants.SUBMISSION_NOTE : SubmissionDetail?.reason;
  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="submission-page-main-wrapper">
          <Row justify={'center'}>
            <Col sm={24} >
              <div className="voting-profile-info section-wrapper mb-1">
                <ProfileInfo GetUser={Profile} />
              </div>
            </Col>
          </Row>
           {SubmissionDetail?.isBlockVotingProccess && <div className="nested-table-wrapper voting-profile-info section-wrapper mb-1">
            <DynamicTable
             columns={blockColumns}
             data={SubmissionDetail?.blocks}
             pagination={false}
             tableLayout="fixed"
            />
             </div>}
          <div className="table-wrapper form-wrap-controller">
            <PermissionsFields
              GetUser={Profile}
              SubmissionDetail={SubmissionDetail}
              setSubmissionDetail={setSubmissionDetail}
              setShowFileViewer={setShowFileViewer}
              showFileViewer={showFileViewer}
              setFilePath={setFilePath}
              setFileName={setFileName}
              fileName={fileName}
              filePath={filePath}
              handleClose={handleClose}
              handleViewFile={handleViewFile}
            />
          </div>
          {statusReason &&
            <Card title="Action Reason" className="mt-3">
              <Typography style={{
                maxHeight: "8em",
                overflowY: "auto"
              }}>
                {statusReason }</Typography>
            </Card>
          }

          {
            
          (SubmissionDetail?.decisionReason) &&
            <Card title="Decision Reason" className="mt-3">
              <Typography style={{
                maxHeight: "8em",
                overflowY: "auto"
              }}>
                {SubmissionDetail?.decisionReason }
               </Typography>
            </Card>
          }
         {SubmissionDetail?.appealDetail?.length > 0 && (
          <Card title="Appeal Details" className="mt-3">
            {SubmissionDetail.appealDetail.map((appeal, index) => (
             <div>
                <p>
                <strong>Group:</strong>{" "}
                {appeal?.blockDetails?.map((block, index) => (
                  <span key={block?.blockId}>
                    {block?.submissionTypesName}  {block?.title ? ` (${block?.title})` : ""}
                    {index < appeal?.blockDetails.length - 1 ? ", " : ""}
                  </span>
                ))}
              </p>
                <p>Reason For Appeal: {appeal?.reasonForAppeal}</p>
                <p>DayTime Phone: {appeal?.dayTimePhone}</p>

                {appeal?.files?.length > 0 && (
                  <UploadButton
                    appealDoc={true}
                    fileList={appeal.files}
                    handleDownload={handleDownload}
                    handleViewFile={handleViewFile}
                    Edit="view"
                  />
                )}
              </div>
            ))}
          </Card>
        )}
        </div>
      )}
    </>
  );
});

export default ArchitecturalRequest;
